import { styled, Fab } from "@mui/material";
import { Fade } from "@mui/material"
import React from "react"

const StyledFab = styled((props) => (
  <Fab {...props} size="small" />
))(({ theme }) => ({
  position: 'absolute',
  bottom: 16,
  right: 16,

  width: 26,
  height: 26,
  minHeight: 26,
  minWidth: 26,

  backgroundColor: theme.palette.mode === 'dark'
    ? theme.palette.primary.light
    : theme.palette.background.paper,
  color: theme.palette.mode === 'dark'
    ? theme.palette.primary.contrastText
    : theme.palette.primary[800],

  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark'
      ? theme.palette.primary[600]
      : theme.palette.grey[200],
  },

  '& .MuiSvgIcon-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
}))

export const TpFullscreenFab = React.forwardRef(function TpFullscreenFab(props, ref) {
  // Fade in on mount, fade out on unmount
  // Fade "in" is always true, so exit animation will play on unmount
  return (
    <Fade in unmountOnExit timeout={350}>
      <StyledFab {...props} ref={ref} />
    </Fade>
  )
})